import { render, staticRenderFns } from "./icon-rotate.vue?vue&type=template&id=f3fe09c0&"
import script from "./icon-rotate.vue?vue&type=script&lang=js&"
export * from "./icon-rotate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports